module.exports = __webpack_public_path__ + "img/photoshop-illustrator-min.33c0000e.webp";